import React, { useEffect, useState } from "react";
import { Typography, CircularProgress } from "@mui/material";
import DoneImage from "../Components/assets/Images/congratsdoneimage.svg";
import ErrorImage from "../Components/assets/Images/errorImage.svg";
import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import { AccountAggregatorFetchDataAPICall } from "../shared/APICalls";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import styles from "../Pages copy/Redirect.module.scss";
import { REDIRECTURL } from "../shared/constants";
import HeaderComp from "../Components/HeaderComp/HeaderComp";

export default function FetchIncomeProof() {
  const navigate = useNavigate();
  const [countDown, setCountDown] = useState(3);
  const [errorMesage, seterrorMessage] = useState("");
  const [loading, setloading] = useState(false);
  const [displayError, setDisplayError] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());

  const doc_id = params.id;
  const state = params.state;
  //   const state = params.state;
  sessionStorage.setItem("access-token", state);

  const GetpanDoc = () => {
    let obj: any = {
      consent_id: doc_id,
    };

    setloading(true);
    setTimeout(() => {
      AccountAggregatorFetchDataAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          setloading(false);
          const redirectParams = new URLSearchParams(window.location.search);
          redirectParams.set("status", "success");
          navigate({ search: urlParams.toString() }, { replace: true });
          setTimeout(() => {
            window.location.href = `${REDIRECTURL}uploaddocuments?status=success`;
          }, 3000);
        })
        .catch((error: any) => {
          setloading(false);
          setDisplayError(true);
          const redirectParams = new URLSearchParams(window.location.search);
          redirectParams.set("status", "failed");
          navigate({ search: urlParams.toString() }, { replace: true });
          seterrorMessage(
            error.response?.data?.message
              ? error.response.data.message
              : "Error fetching document",
          );
          setTimeout(() => {
            seterrorMessage("");
          }, 5000);
          setTimeout(() => {
            window.location.href = `${REDIRECTURL}uploaddocuments?status=failed`;
          }, 3000);
        });
    }, 5000);
  };

  useEffect(() => {
    GetpanDoc();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountDown((prevCountDown) => prevCountDown - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (countDown < 0) {
      setCountDown(3);
    }
  }, [countDown]);

  return (
    <>
      <ErrorSnackBar message={errorMesage} />
      <HeaderComp />
      <div className={styles.mainWrapperTop}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            {loading ? (
              <CircularProgress style={{ width: "80px", height: "80px" }} />
            ) : (
              <img src={displayError ? ErrorImage : DoneImage} />
            )}
          </div>
          <div className={styles.leftContainer}>
            <div className={styles.headerSection}>
              <p className={styles.signup}>
                {" "}
                {loading
                  ? "Inprogress..."
                  : displayError
                    ? "Failed to fetch the data"
                    : "We have obtained your documents"}{" "}
              </p>
              <div className={styles.textdiv}>
                <p className={styles.instructiontext}>
                  {loading
                    ? "Please wait..., we are fetching your Documents. Please don't Close the Window."
                    : `The page will close automatically in ${countDown} seconds, if
                not close manually to continue.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
